import { HTMLAttributes, memo, PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './ButtonContainer.module.css';

function ButtonContainer(props: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  const { children, className } = props;

  return <div className={cls(styles.buttonGroup, className)}>{children}</div>;
}

export default memo(ButtonContainer);
